export default {"src":"https://cdn2.e-farm.com/website-static/_next/static/media/sl.2dc4a5ea.svg","height":6,"width":12,"blurWidth":0,"blurHeight":0};